import React, { useState } from "react";
import Contact from "../contact";
import Testimonials from "../Testimonials";
import arrowIcon from "../../images/home/arrow-icon.svg";
import ellipticalIcon from "../../images/individual/ellipticalIcon.svg";
import rightVector from "../../images/individual/right-vector.svg";
import benifitIcon from "../../images/individual/benifitIcon.png";
import permanentIcon from "../../images/individual/permanent-resident.svg";
import visaImage from "../../images/individual/Patner-Visa.jpg";
import helpIcon from "../../images/individual/helpIcon.svg";
import helpImage from "../../images/individual/smiley-couple.png";
import { FaPlus, FaTimes, FaHeart, FaRing, FaPlane } from "react-icons/fa";
import unlimitedIcon from "../../images/individual/ic_outline-home-work.svg";
import iconPeople from "../../images/individual/akar-icons_people-group.svg";
import materialIcon from "../../images/individual/material-symbols_family-home-outline.svg";
import medicareIcon from "../../images/individual/icon-park-outline_medical-files.svg";
import { Helmet } from "react-helmet-async";

const ProspectiveMarriageVisa300 = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const scrollToContact = () => {
    const contactSection = document.querySelector('#contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Testimonials data for this specific page
  const testimonials = [
    {
      content: "Thanks to Immiget Global, my fiancé's visa was approved in 14 months. Now we're happily married in Sydney!",
      name: "James & Sofia",
      location: "Sydney, Australia",
      visaType: "Subclass 300 Prospective Marriage Visa"
    }
  ];

  return (
    <div>
      <Helmet>
        <title>Subclass 300 Prospective Marriage Visa – Immiget Global Australia</title>
        <meta
          name="description"
          content="Bring your fiancé to Australia with Subclass 300 Prospective Marriage Visa. Expert guidance from Immiget Global for engaged couples. Free consultation available."
        />
      </Helmet>
      
      <div className="w-full h-90 font-Hellix bg-cover bg-center bg-image">
        <div className="max-w-[1440px] px-4 md:px-[75px] m-auto h-full">
          <div className="flex flex-col gap-2 md:gap-2 pt-10 md:pt-20 pb-[90px] h-full justify-center">
            <div className="text-white hellix-font text-center font-semibold text-[22px] md:text-[54px]">
              Prospective Marriage-Fiancé (Subclass 300)
            </div>
            <div className="flex justify-center gap-2 md:gap-4">
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium">
                HOME
              </div>
              <div className="flex items-center">
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
              </div>
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium uppercase">
                Individual & Families
              </div>
              <div className="flex items-center">
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
              </div>
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium uppercase">
                Prospective Marriage-Fiancé (Subclass 300)
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Introduction Section */}
      <div className="xl:flex gap-4 justify-center container max-w-1440px mx-auto px-4 py-4 md:py-10 lg:px-14">
        <div className="xl:w-[50%]">
          <h1 className="xl:text-[30px] text-[24px] max-xl:text-center text-blue mt-6 font-semibold hellix-font">
            What is the Prospective Marriage Visa (Subclass 300)?
          </h1>
          <p className="max-xl:text-center hellix-font text-blue text-lg xl:text-[20px] font-normal">
            Planning to marry your partner in Australia? The Prospective Marriage Visa (Subclass 300) allows engaged couples to reunite in Australia and get married within 9 months of arrival. This temporary visa provides your fiancé(e) with work and study rights while planning your wedding.
          </p>
          
          {/* Key Features */}
          <div className="mt-6">
            <h3 className="text-blue text-xl font-semibold hellix-font mb-3 max-xl:text-center">Key Features:</h3>
            <div className="space-y-2">
              <div className="flex gap-2 max-xl:justify-center">
                <FaRing className="text-blue mt-1 min-w-[16px]" />
                <span className="text-blue text-lg hellix-font">Valid for 9 months (must marry within this period)</span>
              </div>
              <div className="flex gap-2 max-xl:justify-center">
                <FaPlane className="text-blue mt-1 min-w-[16px]" />
                <span className="text-blue text-lg hellix-font">No limit on travel in/out of Australia</span>
              </div>
              <div className="flex gap-2 max-xl:justify-center">
                <FaHeart className="text-blue mt-1 min-w-[16px]" />
                <span className="text-blue text-lg hellix-font">Pathway to Partner Visa (Subclass 820/801) after marriage</span>
              </div>
            </div>
          </div>
        </div>
        <div className="xl:w-[50%] max-xl:justify-center max-xl:flex max-xl:mt-4">
          <img src={visaImage} alt="Prospective Marriage Visa" />
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Eligibility Requirements */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            Eligibility Requirements
          </h1>
        </div>
        <div className="text-blue font-normal text-lg lg:text-[20px] mt-2 hellix-font">
          To qualify for the Subclass 300 visa, you must:
        </div>
        
        <div className="mt-6 space-y-6">
          {/* Requirement 1 */}
          <div>
            <h3 className="text-blue text-xl font-semibold hellix-font mb-3">1. Be Genuinely Engaged</h3>
            <div className="lg:ml-4">
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg xl:text-[20px] font-normal hellix-font">
                  Provide evidence of a real intention to marry (wedding plans, joint finances, communication records)
                </span>
              </div>
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg xl:text-[20px] font-normal hellix-font">
                  Marry within 9 months of visa grant
                </span>
              </div>
            </div>
          </div>

          {/* Requirement 2 */}
          <div>
            <h3 className="text-blue text-xl font-semibold hellix-font mb-3">2. Meet Age & Relationship Criteria</h3>
            <div className="lg:ml-4">
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg xl:text-[20px] font-normal hellix-font">
                  Both partners must be 18+ years old
                </span>
              </div>
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg xl:text-[20px] font-normal hellix-font">
                  Have met in person (exceptions only for cultural/legal reasons)
                </span>
              </div>
            </div>
          </div>

          {/* Requirement 3 */}
          <div>
            <h3 className="text-blue text-xl font-semibold hellix-font mb-3">3. Sponsorship by an Eligible Partner</h3>
            <div className="lg:ml-4">
              <div className="text-blue text-lg xl:text-[22px] font-normal hellix-font mb-2">
                The Australian sponsor must be:
              </div>
              <div className="lg:ml-4">
                <div className="flex gap-2">
                  <img src={rightVector} alt="" className="min-w-[30px]" />
                  <span className="text-blue text-lg xl:text-[20px] font-normal hellix-font">
                    An Australian citizen, PR holder, or eligible NZ citizen
                  </span>
                </div>
                <div className="flex gap-2">
                  <img src={rightVector} alt="" className="min-w-[30px]" />
                  <span className="text-blue text-lg xl:text-[20px] font-normal hellix-font">
                    Free from limiting sponsorship restrictions
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Requirement 4 */}
          <div>
            <h3 className="text-blue text-xl font-semibold hellix-font mb-3">4. Health & Character Requirements</h3>
            <div className="lg:ml-4">
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg xl:text-[20px] font-normal hellix-font">
                  Pass medical exams and police checks
                </span>
              </div>
            </div>
          </div>

          {/* Requirement 5 */}
          <div>
            <h3 className="text-blue text-xl font-semibold hellix-font mb-3">5. No Previous Visa Refusals or Cancellations</h3>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Benefits Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            Benefits of the Subclass 300 Visa
          </h1>
        </div>
        <p className="text-blue font-normal text-lg lg:text-[20px] mt-2 hellix-font">
          The Prospective Marriage Visa offers several advantages for engaged couples planning their future together in Australia.
        </p>
        <div className="flex flex-wrap justify-between mt-8">
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <FaHeart className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg font-normal text-center hellix-font">
              Reunite with your partner in Australia
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <FaRing className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg font-normal text-center hellix-font">
              Legally marry within 9 months
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <img src={unlimitedIcon} alt="work-icon" />
            </div>
            <div className="text-blue text-lg font-normal text-center hellix-font">
              Work and study while in Australia
            </div>
          </div>
        </div>
        <div className="flex gap-8 justify-center flex-wrap mt-8">
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <FaPlane className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg font-normal max-md:px-2 text-center hellix-font">
              Travel freely in and out of the country
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <img src={permanentIcon} alt="pr-icon" />
            </div>
            <div className="text-blue text-lg text-center max-md:px-2 font-normal hellix-font">
              Pathway to permanent residency (via Partner Visa 820/801)
            </div>
          </div>
        </div>
      </div>

      {/* Application Process */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            How to Apply for the Subclass 300 Visa
          </h1>
        </div>
        <div className="lg:ml-8 hellix-font mt-3">
          <div className="flex gap-2">
            <div className="hellix-font text-lg lg:text-[20px] font-semibold text-blue">
              Step 1:
            </div>
            <div className="hellix-font text-lg lg:text-[20px] font-normal text-blue">
              <strong>Gather Documents</strong> - Proof of genuine relationship (photos, chats, joint accounts, wedding plans), Notice of Intended Marriage (NOIM) from an Australian celebrant, Sponsorship form (completed by the Australian partner)
            </div>
          </div>
          <div className="flex gap-2 mt-2">
            <div className="hellix-font text-lg lg:text-[20px] font-semibold text-blue">
              Step 2:
            </div>
            <div className="hellix-font text-lg lg:text-[20px] font-normal text-blue">
              <strong>Lodge the Application</strong> - Submit online via the Department of Home Affairs
            </div>
          </div>
          <div className="flex gap-2 mt-2">
            <div className="hellix-font text-lg lg:text-[20px] font-semibold text-blue">
              Step 3:
            </div>
            <div className="hellix-font text-lg lg:text-[20px] font-normal text-blue">
              <strong>Wait for Processing</strong> - Current processing time: 12-24 months (varies by case)
            </div>
          </div>
          <div className="flex gap-2 mt-2">
            <div className="hellix-font text-lg lg:text-[20px] font-semibold text-blue">
              Step 4:
            </div>
            <div className="hellix-font text-lg lg:text-[20px] font-normal text-blue">
              <strong>Visa Grant & Entry to Australia</strong> - Once approved, your partner must enter Australia before the expiry date. Marry within 9 months and apply for a Partner Visa (Subclass 820/801)
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Why Choose Immiget Global */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            Why Choose Immiget Global?
          </h1>
        </div>
        <div className="text-blue font-normal text-lg lg:text-[20px] mt-2 hellix-font">
          Start Your Love Story in Australia Today! We provide expert guidance for your Subclass 300 visa application:
        </div>
        <div className="lg:ml-4 mt-4">
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg lg:text-[20px] font-normal hellix-font">
              <strong>Expert Guidance</strong> – We simplify complex partner visa processes
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg lg:text-[20px] font-normal hellix-font">
              <strong>High Approval Rate</strong> – Proven success with fiancé visa applications
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg lg:text-[20px] font-normal hellix-font">
              <strong>Fast Processing Support</strong> – We help avoid delays
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg lg:text-[20px] font-normal hellix-font">
              <strong>Post-Visa Assistance</strong> – Support for Partner Visa transition
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* How Immiget Will Help You */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={helpIcon} alt="help" />
          </div>
          <h1 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            How Immiget Will Help You?
          </h1>
        </div>
        <div className="text-blue font-normal text-lg lg:text-[20px] mt-2 hellix-font">
          Immiget Global is here to assist engaged couples at every stage of their Subclass 300 visa journey. Our team provides:
        </div>
        <div className="xl:flex gap-6 mt-4">
          <div className="xl:w-[50%]">
            <img src={helpImage} alt="happy couple" className="h-[100%]" />
          </div>
          <div className="xl:w-[50%] max-xl:mt-4 flex flex-col gap-1">
            <div>
              <ul className="list-inside">
                <li className="text-blue text-xl lg:text-[20px] hellix-font font-semibold">
                  Relationship Evidence Guidance:
                  <span className="font-normal">
                    We help you compile compelling evidence of your genuine relationship and intention to marry.
                  </span>
                </li>
              </ul>
            </div>
            <div>
              <ul className="list-inside">
                <li className="text-blue text-xl lg:text-[20px] hellix-font font-semibold">
                  Document Preparation:
                  <span className="font-normal">
                    Our experts ensure all required documents are properly prepared and meet immigration requirements.
                  </span>
                </li>
              </ul>
            </div>
            <div>
              <ul className="list-inside">
                <li className="text-blue text-xl lg:text-[20px] hellix-font font-semibold">
                  Application Management:
                  <span className="font-normal">
                    We handle the complete application process and provide regular updates on your case status.
                  </span>
                </li>
              </ul>
            </div>
            <div>
              <ul className="list-inside">
                <li className="text-blue text-xl lg:text-[20px] hellix-font font-semibold">
                  Transition Support:
                  <span className="font-normal">
                    After marriage, we assist with your Partner Visa (820/801) application for permanent residency.
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <h1 className="lg:text-[28px] text-2xl text-center text-blue font-semibold hellix-font">
          Prospective Marriage Visa FAQs
        </h1>
        <p className="text-blue font-normal text-xl lg:text-[20px] text-center hellix-font">
          Get answers to common questions about the Subclass 300 Prospective Marriage Visa.
        </p>

        <div className="accordion-container mt-8">
          {/* FAQ 1 */}
          <div className="accordion">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(1)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                Can we extend the 9-month visa period?
              </h2>
              {activeIndex === 1 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 1 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  No, the 9-month period cannot be extended. However, you can apply for a Partner Visa (Subclass 820) after marriage to continue living in Australia.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 2 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(2)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                What if we don't marry within 9 months?
              </h2>
              {activeIndex === 2 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 2 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  The visa expires, and your partner must leave Australia. It's essential to plan your wedding within the 9-month timeframe.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 3 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(3)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                Can my fiancé(e) work on this visa?
              </h2>
              {activeIndex === 3 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 3 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  Yes, full work rights are granted with the Subclass 300 visa. Your fiancé(e) can work for any employer in Australia.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 4 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(4)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                How long does processing take?
              </h2>
              {activeIndex === 4 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 4 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  Processing typically takes 12-24 months, but can vary depending on the complexity of your case and completeness of documentation.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 5 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(5)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                Do we need to have met in person?
              </h2>
              {activeIndex === 5 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 5 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  Yes, you must have met in person before applying. Exceptions are only made for compelling cultural or legal reasons.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 6 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(6)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                What documents prove our genuine relationship?
              </h2>
              {activeIndex === 6 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 6 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  Photos together, communication records (messages, emails, calls), joint financial accounts, travel records, wedding planning documents, and statements from family and friends.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Testimonials Section */}
      <Testimonials 
        testimonials={testimonials} 
        title="Success Stories from Happy Couples"
      />

      <div id="contact-section">
        <Contact />
      </div>
    </div>
  );
};

export default ProspectiveMarriageVisa300;